import Vue from 'vue'
import Vuex from 'vuex'
import payment from './payment'

export type Site = {
  id: string, 
  link?: string,
  name?: string
  unique?: string,
  defaultLink?: string
}

export type State = {
  auth?: string | null
  searchPage?: string | null
  info?: string | null
  title?: string | null
  total?: string | null
  ticker?: string | null
  commit: Function
  counts: Array<number>
  lastlogin?: string | null
  sites: Site[]
}



Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    payment
  },

  state : {

    auth : null, 
    searchPage: null,

  },
  getters: {

  },
  actions: {
  },
  mutations: {

  },
})